import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  map,
  concatMap,
  mergeMap,
  switchMap,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { LocaleService } from '../../core/service/locale.service';
import CONSTANTS from 'src/@utility/constants';

import * as LocaleActions from './locale.actions';
import { AppInitService } from 'src/app/core/service/app-init.service';
import { StorageService } from 'src/app/core/service/storage.service';

@Injectable()
export class LocaleEffects {
  loadLocales$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocaleActions.loadLocales),
      concatMap(() =>
        this.localeService.load().pipe(
          map((data: any) => {
            return LocaleActions.loadLocalesSuccess({ data });
          }),
          catchError((error: Error) => {
            return of(LocaleActions.loadLocalesFailure({ error }));
          })
        )
      )
    );
  });

  loadKeyValues$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocaleActions.loadAppKeyValues),
      switchMap((action) =>
        this.appInitService.load(action.option).pipe(
          map((data: any) => {
            return LocaleActions.loadAppKeyValuesSuccess({ data });
          }),
          catchError((error: Error) => {
            return of(LocaleActions.loadAppKeyValuesFailure({ error }));
          })
        )
      )
    );
  });

  updateDefaultLocale$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocaleActions.updateDefaultLocale),
      map((action) => {
        const appKeyValue = this.storageService.getItem(
          CONSTANTS.appKeyValuesStoreKey
        );
        appKeyValue.DEFAULT_LOCALE = action.locale;
        this.storageService.setItem(
          CONSTANTS.appKeyValuesStoreKey,
          appKeyValue
        );
        return LocaleActions.loadDefaultLocale(action);
      })
    );
  });

  constructor(
    private actions$: Actions,
    private localeService: LocaleService,
    private appInitService: AppInitService,
    private storageService: StorageService
  ) {}
}
